




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CarteObjet extends Vue {
	@Prop({ required: true })
	objet!: any;

	$refs!: {
		image: HTMLImageElement;
	};

	public isPortrait = true;

	get imgUrl() {
		return require('@/assets/img/' + this.objet.fichier + '.jpg');
	}

	get iconeLien() {
		return require('@/assets/img/icone-lien.png');
	}

	public imageLoaded(): void {
		if (typeof this.$refs.image !== 'undefined') {
			if (this.$refs.image.width > this.$refs.image.height) {
				this.isPortrait = false;
			}
		}
	}

	protected mounted(): void {
		if (typeof this.$refs.image !== 'undefined') {
			this.$refs.image.addEventListener('load', this.imageLoaded);
		}
	}
}
